import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/page-image/jmjl/测量仪.png';
const _hoisted_1 = {
  class: "jmjl-wrapper"
};
const _hoisted_2 = {
  class: "jmjl-page"
};
const _hoisted_3 = {
  class: "content-wrapper"
};
const _hoisted_4 = {
  class: "right-content"
};
const _hoisted_5 = {
  class: "section"
};
const _hoisted_6 = {
  class: "section"
};
export default /*@__PURE__*/_defineComponent({
  __name: 'Jmjl',
  setup(__props) {
    // 组件已通过unplugin-vue-components自动注册为全局组件，无需手动导入
    return (_ctx, _cache) => {
      const _component_Breadcrumb = _resolveComponent("Breadcrumb");
      const _component_SideMenu = _resolveComponent("SideMenu");
      const _component_SectionTitle = _resolveComponent("SectionTitle");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Breadcrumb, {
        items: [{
          label: '首页',
          path: '/'
        }, {
          label: '产品服务'
        }, {
          label: '精密计量'
        }]
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_SideMenu, {
        activeId: "jmjl"
      }), _createElementVNode("div", _hoisted_4, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "page-title"
      }, "非接触光学测量仪", -1)), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "publish-time"
      }, "发布时间：2025年1月1日", -1)), _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "product-image"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "非接触光学测量仪"
      })], -1)), _createElementVNode("div", _hoisted_5, [_createVNode(_component_SectionTitle, {
        title: "产品介绍"
      }), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "intro-content"
      }, [_createElementVNode("p", null, "该产品用于复杂、大尺寸工件的精密测量,实现对磨具、塑料零件、金属零件、曲面结构、狭窄弯曲、褶皱边缘等部位的细节测量,一次性提供测量目标物体的尺寸、形状、表面质量等多重特征参数,具有高精度、高速度、非破坏性等特点。")], -1))]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_SectionTitle, {
        title: "主要参数"
      }), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "params-content"
      }, [_createElementVNode("div", {
        class: "params-title"
      }, "产品特点"), _createElementVNode("div", {
        class: "params-list"
      }, [_createElementVNode("p", null, "大行程、高精度:XY行程300mm,XYZ轴分辨率<0.1um"), _createElementVNode("p", null, "丰富的测量辅助工具:体积、面积、几何公差、尺寸、粗糙度等"), _createElementVNode("p", null, "可单次测量多个目标物"), _createElementVNode("p", null, "提供数据分析与检测报告")])], -1))])])])]), _createVNode(_component_Footer)]);
    };
  }
});